var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    zoomAndPan: "magnify",
    viewBox: "0 0 750 749.999995",
    height: 24,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "71bdbc28f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 130 131 L 619 131 L 619 620 L 130 620 Z M 130 131 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b01337206b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 374.996094 124.132812 L 625.839844 374.976562 L 374.996094 625.824219 L 124.148438 374.976562 Z M 374.996094 124.132812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e54e4fa4bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 374.996094 124.132812 L 625.839844 374.976562 L 374.996094 625.824219 L 124.148438 374.976562 Z M 374.996094 124.132812 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#71bdbc28f7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b01337206b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e54e4fa4bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 386.695312 387.335938 L 606.589844 387.335938 C 613.285156 387.339844 618.710938 381.910156 618.707031 375.21875 C 618.707031 368.523438 613.28125 363.097656 606.589844 363.101562 L 386.695312 363.101562 L 386.695312 143.203125 C 386.695312 136.507812 381.265625 131.082031 374.578125 131.085938 C 367.882812 131.085938 362.457031 136.511719 362.460938 143.203125 L 362.460938 363.101562 L 142.5625 363.097656 C 135.867188 363.097656 130.441406 368.523438 130.445312 375.214844 C 130.445312 378.5625 131.800781 381.59375 133.992188 383.785156 C 136.183594 385.976562 139.21875 387.335938 142.5625 387.332031 L 362.457031 387.335938 L 362.460938 607.230469 C 362.460938 610.578125 363.816406 613.609375 366.007812 615.800781 C 368.199219 617.992188 371.234375 619.347656 374.578125 619.347656 C 381.269531 619.347656 386.699219 613.921875 386.695312 607.230469 Z M 386.695312 387.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus_white.c0dee649c6bb722ed2fc30a09658f490.svg";
export { ForwardRef as ReactComponent };